import React from 'react'
import { DatePicker, Col, Form } from 'antd';

export default class DatePickerRange extends React.Component {

  constructor(props) {
    super(props);
    const value = props.value || {};
    this.state = {
      tuNgay: value.tuNgay || undefined,
      denNgay: value.denNgay || undefined
    }
  }

  disabledStartDate = (tuNgay) => {
    if (tuNgay) {
      const denNgay = this.state.denNgay
      if (!tuNgay || !denNgay) {
        return false
      }
      return tuNgay.valueOf() > denNgay.valueOf()
    }
  }

  disabledEndDate = (denNgay) => {
    const tuNgay = this.state.tuNgay
    if (!denNgay || !tuNgay) {
      return false
    }
    return denNgay.valueOf() <= tuNgay.valueOf()
  }

  onChangeStart = (tuNgay, name) => {
    if (tuNgay) {
      this.setState({
        [name]: tuNgay
      }, () => this.triggerChange({ tuNgay }));
    }
  }

  onChangeEnd = (denNgay, name) => {
    this.setState({
      [name]: denNgay
    },() => this.triggerChange({ denNgay }));
  }

  triggerChange = (changedValue) => {
    const onChange = this.props.onChange;
    if (onChange) {

      onChange(Object.assign({}, this.state, changedValue));
    }
  }

  render() {
    const state = this.state;
    const { type } = this.props;
    if (type === 'search') {
      return (
        <React.Fragment>
          <Col md={12} xs={24}>
            <Form.Item label="Từ ngày">
              <DatePicker
                style={{ width: '100%' }}
                {...this.props}
                className={this.props.className}
                showToday={false}
                disabledDate={(value) => this.disabledStartDate(value)}
                value={state.tuNgay}
                placeholder='Từ ngày'
                onChange={(value) => this.onChangeStart(value, 'tuNgay')}
                format='DD/MM/YYYY'
              />
            </Form.Item>

          </Col>
          <Col md={12} xs={24}>
            <Form.Item label="Đến ngày">
              <DatePicker
                style={{ width: '100%' }}
                {...this.props}
                className={this.props.className}
                showToday={false}
                disabledDate={(value) => this.disabledEndDate(value)}
                value={state.denNgay}
                placeholder='Đến ngày'
                onChange={(value) => this.onChangeEnd(value, 'denNgay')}
                format='DD/MM/YYYY'
              />
            </Form.Item>
          </Col>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <DatePicker
            style={{ minWidth: 160 }}
            {...this.props}
            className={this.props.className}
            showToday={false}
            disabledDate={(value) => this.disabledStartDate(value)}
            value={state.tuNgay}
            placeholder='Từ ngày'
            onChange={(value) => this.onChangeStart(value, 'tuNgay')}
            format='DD/MM/YYYY'
          />
          <DatePicker
            style={{ minWidth: 160, paddingLeft: '10px' }}
            {...this.props}
            className={this.props.className}
            showToday={false}
            disabledDate={(value) => this.disabledEndDate(value)}
            value={state.denNgay}
            placeholder='Đến ngày'
            onChange={(value) => this.onChangeEnd(value, 'denNgay')}
            format='DD/MM/YYYY'
          />
        </React.Fragment>
      )
    }
  }
}
